import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import PropTypes from "prop-types";
import { DateTimeInputField } from "../../../components/Form/FormComponents";
import { Box } from "@mui/material";

export function ApprenticeLists({ apprenticesList, requestData }) {
	// const onAcceptClick = () => {
	// 	console.log("accept", requestData, apprenticesList);
	// };
	// const onRejectClick = () => {
	// 	console.log("accept", requestData, apprenticesList);
	// };

	return (
		<TableContainer component={Paper}>
			<Table sx={{ width: 800 }} aria-label='simple table'>
				<TableHead>
					<TableRow>
						<TableCell sx={{ minWidth: 115 }}>Trn ID</TableCell>
						<TableCell sx={{ minWidth: 155 }} align='left'>
							Date / Time
						</TableCell>
						<TableCell sx={{ minWidth: 110 }} align='left'>
							Apprentice Name
						</TableCell>
						<TableCell sx={{ minWidth: 250 }} align='left'>
							Business Description
						</TableCell>
						<TableCell sx={{ minWidth: 250 }} align='left'>
							Purpose
						</TableCell>
						<TableCell sx={{ minWidth: 110 }} align='left'>
							Status
						</TableCell>
						<TableCell sx={{ minWidth: 110 }} align='center'>
							Action
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{apprenticesList?.map((row) => (
						<TableRow key={row?.transactionId} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
							<TableCell component='th' scope='row'>
								{row?.transactionId}
							</TableCell>
							<TableCell component='th' scope='row'>
								<DateTimeInputField value={row?.date} />
							</TableCell>
							<TableCell component='th' scope='row'>
								{row?.name}
							</TableCell>
							<TableCell>{row?.businessInfo?.description || "--"}</TableCell>
							<TableCell sx={{ wordBreak: "break-word" }}>{row?.businessInfo?.purpose || "--"}</TableCell>
							<TableCell
								sx={{
									color: row?.status === "approved" ? "green" : row?.status === "rejected" ? "red" : "black",
									textTransform: "capitalize",
								}}>
								{row.status || "--"}
							</TableCell>
							<TableCell align='center'>
								{requestData?.requestType === "investor-creates" ? (
									<span>N/A</span>
								) : (
									<Box display='flex' gap={2}>
										{/* <ActionBtn text='accept' color='green' onClick={onAcceptClick} />
										<ActionBtn text='reject' color='red' onClick={onRejectClick} /> */}
									</Box>
								)}
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
}

ApprenticeLists.propTypes = {
	apprenticesList: PropTypes.array,
	requestData: PropTypes.object,
};

export const ActionBtn = ({ text, color, onClick }) => {
	return (
		<button className='action-btn' style={{ background: color }} onClick={onClick} type='button'>
			{text}
		</button>
	);
};

ActionBtn.propTypes = {
	text: PropTypes.string,
	color: PropTypes.string,
	onClick: PropTypes.func,
};
